import { Component, effect, HostListener, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CellAdapter } from '../cell-adapter.component';

@Component({
  host: {
    ngSkipHydration: 'true',
  },
  selector: 'lepi-checkbox-cell',
  imports: [FormsModule],
  template: `
    <div class="flex justify-center">
      <input
        [(ngModel)]="value"
        (ngModelChange)="valueChange($event)"
        type="checkbox"
        class="rounded checkbox-primary border-neutral-300 checkbox" />
    </div>
  `,
})
export class CheckboxCell extends CellAdapter {
  @HostListener('click', ['$event']) handleClick(ev: MouseEvent) {
    ev.stopPropagation();
  }

  value = model<boolean>(false);
  selecteds = model<any[]>([]);

  constructor() {
    super();

    // 선택된 row의 uniqueId를 가져와서 체크박스 선택 여부를 결정
    effect(() => {
      this.value.set(this.selecteds().includes(this.row()));
    });
  }

  /**
   * @description 체크박스 선택/해제
   * @param ev
   */
  valueChange(ev: boolean) {
    const array = this.selecteds() || [];

    if (ev) {
      this.selecteds.set([...(array || []), this.row()]);
    } else {
      this.selecteds.update(value =>
        value.filter(obj => {
          return obj['uniqueId'] != this.row()['uniqueId'];
        })
      );
    }
  }
}
